import { CSSProperties } from "react";

export const mapDataCloudfrontURL = "https://d24ye0ax7gglwd.cloudfront.net/";

export const mapFillColorStrategy = {
  interpolate: "interpolate",
  step: "step",
};

export const mapMenuStyle: CSSProperties = {
  top: 0,
  left: 0,
  paddingTop: "14px",
  paddingLeft: "14px",
  width: "30px",
};
